import React from 'react';
import PropTypes from 'prop-types';

import Medialib from 'api/resources/medialib';
import { processErrorByAlert } from 'utils/getErrors';
import getPrefix from 'utils/getPrefix';

import LoadFileBlock from 'admin-editor/components/LoadFileBlock';
import PhotoFigure from 'styled/Editor/PhotoFigure';
import LeftBlockWrapper from 'styled/Editor/LeftBlockWrapper';
import MediaContent from 'admin-editor/components/MediaContent';

import DeleteIcon from 'icons/Delete';
import SimpleButton from 'styled/Buttons/SimpleButton';
import Container from 'styled/Editor/Container';
import SubBlock from 'styled/Editor/SubBlock';
import FormLabel from 'styled/Editor/FormLabel';
import TextLength from 'styled/Editor/TextLength';

import TextareaStyled from './TextareaStyled';

const TITLE_MAX_LENGTH = 80;

class PublicationCoverBlock extends React.PureComponent {
  state = { loading: false }

  handleLoad = async (file) => {
    this.setState({ loading: true });
    try {
      const response = await Medialib.post({
        upload: file,
        prefix: getPrefix(),
      });

      this.setState({ loading: false });
      this.props.onLoad(response.data[0]);
    } catch (err) {
      this.setState({ loading: false });
      processErrorByAlert(err);
    }
  }

  render() {
    if (!this.props.url && this.props.disabled) return null;

    if (!this.props.url) {
      return (
        <LoadFileBlock
          label="Обложка"
          onLoad={this.handleLoad}
          loading={this.state.loading}
        />
      );
    }

    return (
      <Container>
        <LeftBlockWrapper>
          <FormLabel>Обложка</FormLabel>

          <PhotoFigure>
            <MediaContent
              title={this.props.title}
              url={this.props.url}
              fileType={this.props.fileType}
            />

            <figcaption style={{ display: 'flex', alignItems: 'center' }}>
              <TextareaStyled
                value={this.props.title}
                maxLength={TITLE_MAX_LENGTH}
                placeholder="Добавьте описание к обложке"
                onChange={this.props.onTitleChange}
              />

              <TextLength>{this.props.title ? this.props.title.length : '0'}/{TITLE_MAX_LENGTH}</TextLength>
            </figcaption>
          </PhotoFigure>
        </LeftBlockWrapper>

        <SubBlock style={{ display: 'flex' }}>
          <SimpleButton
            type="button"
            onClick={this.props.onDelete}
            style={{ marginTop: 'auto', marginBottom: '14px' }}
            disabled={this.props.disabled}
          >
            <DeleteIcon />
          </SimpleButton>
        </SubBlock>
      </Container>
    );
  }
}

PublicationCoverBlock.propTypes = {
  url: PropTypes.string,
  fileType: PropTypes.string,
  title: PropTypes.string,
  disabled: PropTypes.bool,

  onLoad: PropTypes.func,
  onTitleChange: PropTypes.func,
  onDelete: PropTypes.func,
};

PublicationCoverBlock.defaultProps = {
  url: '',
  fileType: 'image/jpeg',
  title: '',
  disabled: false,

  onLoad: () => {},
  onTitleChange: () => {},
  onDelete: () => {},
};

export default PublicationCoverBlock;
